import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { createChat } from "../../store/actions/chats";
import DatetimeFormat from "../DateTimeFormat";
import ChatDescription from "../ChatDescription";
import SystemMessages from "../SystemMessages";
import InfiniteScroll from "react-infinite-scroller";
import DefaultUserImage from "../../assets/img/avatar_user_black.png";
import DefaultGroupImage from "../../assets/img/avatar_group_black.png";
import { ReactComponent as MoreSvg } from "../../assets/icon/ic_more_horiz_24dp.svg";
import { List, Card, Avatar, Icon, Badge } from "antd";

import "./ChatList.scss";

const { Meta } = Card;

function GetRightInfoContent({
  chat,
  timestamp,
  unread,
  formatMessage,
  optionBoxOpenId,
  setOptionBoxRef,
  onOptionDivClick,
  toggleOptionsBox,
  optionBoxDirection,
  emitEvent,
  itemDescription,
  archiveChat,
  flags,
}) {
  const chatConfig = window.Social.getChatConfig();
  let alternativeArchive;

  if (chatConfig.allowFlags && chat.flags && chat.flags.length === 1) {
    let currentFlag = flags.find((elem) => elem.id === chat.flags[0].id);
    if (currentFlag) {
      alternativeArchive = currentFlag.alternativeArchiveText;
    }
  }

  return (
    <div className="right-info">
      <div className="right-info-options">
        <OptionsBox
          chat={chat}
          optionBoxOpenId={optionBoxOpenId}
          setOptionBoxRef={setOptionBoxRef}
          toggleOptionsBox={(e) => toggleOptionsBox(e, chat)}
          direction={optionBoxDirection}
          archiveChat={archiveChat}
          emitEvent={emitEvent}
          itemDescription={itemDescription}
          alternativeArchive={alternativeArchive}
          formatMessage={formatMessage}
          onOptionDivClick={onOptionDivClick}
        />
      </div>
      <div className="right-info-time">
        <DatetimeFormat className="short" short dateTime={timestamp} />
        {unread > 0 && (
          <Badge className="unread-messages" count={unread} overflowCount={9} />
        )}
      </div>
    </div>
  );
}

function OptionsBox({
  chat,
  optionBoxOpenId,
  setOptionBoxRef,
  onOptionDivClick,
  toggleOptionsBox,
  direction,
  emitEvent,
  itemDescription,
  archiveChat,
  alternativeArchive,
  formatMessage,
}) {
  let chatEventActions;

  if (chat.elements && chat.elements.length > 0) {
    let eventActions = Object.values(window.Social.getChatEventsConfig()).map(
      (elem) => {
        return (
          <span
            className="message-box-option"
            key={elem.eventName}
            onClick={() => emitEvent(elem.eventName, chat)}
          >
            {elem.label}
          </span>
        );
      }
    );

    if (eventActions && eventActions.length > 0) {
      eventActions.unshift(
        <span className="title" key="item-description">
          {itemDescription}
        </span>
      );

      eventActions.push(
        <span className="separator" key="item-separator"></span>
      );

      chatEventActions = eventActions;
    }
  }

  return (
    <div className="option-box-container">
      <Icon
        className={`action-button ${
          optionBoxOpenId === chat.id ? "active" : ""
        }`}
        onClick={toggleOptionsBox}
        component={MoreSvg}
      />

      {optionBoxOpenId === chat.id && (
        <div
          className={`message-box-options-box ${direction}`}
          ref={setOptionBoxRef}
          onClick={onOptionDivClick}
        >
          <span className="title">
            {formatMessage({ id: "general.message" })}
          </span>

          <span className="separator"></span>

          {chatEventActions}

          {chat.archived ? (
            <span className="message-box-option">
              {formatMessage({ id: "chat.noOptionsAvailable" })}
            </span>
          ) : (
            <span
              className="message-box-option"
              onClick={(e) => archiveChat(e, chat)}
            >
              {alternativeArchive
                ? formatMessage(
                    { id: alternativeArchive },
                    { flag: chat.flags[0].flagName }
                  )
                : formatMessage({ id: "chat.archiveMessage" })}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

class ChatList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: null,
      optionBoxOpenId: false,
      optionBoxDirection: "bottom",
      unread: {},
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  removeReactivity(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  onCardClick(item) {
    this.props.onCardClick(item, true);
  }

  getItemTitle(item) {
    const { formatMessage } = this.props.intl;
    const { flags, mentions } = this.props;
    const currentFlag = flags.find(
      (elem) => elem.id === (item.flags && item.flags[0] && item.flags[0].id)
    );
    const archivedPrefix =
      (currentFlag && currentFlag.alternativeArchivedPrefix) ||
      "chat.archivedPrefix";

    let description;
    if (item.description) {
      description = (
        <span
          className={`item-title ${this.isChatUnread(item) ? "unread" : ""}`}
        >
          {mentions && mentions[item.id] ? `(${mentions[item.id]}) ` : ""}
          {item.archived
            ? `${formatMessage({ id: archivedPrefix })} ${item.description}`
            : item.description}
        </span>
      );
    } else {
      description = (
        <span
          className={`item-title ${this.isChatUnread(item) ? "unread" : ""}`}
        >
          {mentions && mentions[item.id] ? `(${mentions[item.id]}) ` : ""}
          {formatMessage(
            {
              id: "chat.noDescriptionTitle",
            },
            {
              name: item.createdBy.username,
              archived: item.archived
                ? formatMessage({ id: archivedPrefix })
                : "",
              number: item.recipients.length - 1,
            }
          )}
        </span>
      );
    }
    return description;
  }

  getItemAvatar(item) {
    let avatar;
    if (item.recipients.length === 2) {
      avatar = DefaultUserImage;
    } else {
      avatar = DefaultGroupImage;
    }
    return (
      <div className="chat-list-item-avatar">
        <Avatar src={avatar} />
        <Badge overflowCount={9} count={item.unread} />
      </div>
    );
  }

  onHover(item) {
    // if (this.hover !== item.id) {
    //   this.setState({
    //     hover: item.id
    //   })
    // }
  }

  onLeave() {
    if (this.state.optionBoxOpenId) {
      this.setState({
        optionBoxOpenId: null,
      });
      document.removeEventListener("click", this.handleClickOutside);
    }
  }

  toggleOptionsBox(e, chat) {
    e && e.stopPropagation();

    this.setState({
      optionBoxOpenId: chat && chat.id,
      optionBoxDirection:
        e.target && e.target.getBoundingClientRect().y > window.innerHeight / 2
          ? "top"
          : "bottom",
    });

    document.addEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.optionBoxRef && !this.optionBoxRef.contains(event.target)) {
      event.stopPropagation();
      this.setState(
        {
          optionBoxOpenId: false,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  }

  onOptionDivClick(e) {
    e.stopPropagation();
  }

  setOptionBoxRef(node) {
    this.optionBoxRef = node;
  }

  isChatUnread(item) {
    // return item.newMessages || this.props.notifications[item.id]
    return item.newMessages;
  }

  emitEvent = (eventName, chat) => {
    if (window.hasOwnProperty("Social")) {
      window.Social.emit(eventName, chat.elements);

      this.setState(
        {
          optionBoxOpenId: null,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  };

  archiveChat = (e, chat) => {
    this.props.archiveChat(e, chat);

    this.setState(
      {
        optionBoxOpenId: null,
      },
      document.removeEventListener("click", this.handleClickOutside)
    );
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { hasErrors } = this.props;
    return (
      <div className="chat-list-container">
        {!hasErrors ? (
          <InfiniteScroll
            loadMore={this.props.handleInfiniteOnLoad}
            hasMore={this.props.hasMoreChats}
            initialLoad={false}
            useWindow={false}
          >
            <List
              id={this.state.id}
              className="chat-list"
              locale={{ emptyText: "" }}
              dataSource={this.props.list}
              loading={this.props.loading}
              renderItem={(item) => (
                <List.Item
                  className={this.isChatUnread(item) && "unread"}
                  onMouseLeave={() => this.onLeave()}
                  // onMouseEnter={() => this.onHover(item)}
                  onClick={() => this.onCardClick(item)}
                >
                  <Card bordered={false} className="chat-list-wrapper">
                    <Meta
                      avatar={this.getItemAvatar(item)}
                      title={this.getItemTitle(item)}
                      description={
                        <ChatDescription chat={item} flags={this.props.flags} />
                      }
                    />
                    <GetRightInfoContent
                      chat={item}
                      unread={this.isChatUnread(item)}
                      timestamp={item.lastMessageDate}
                      optionBoxOpenId={this.state.optionBoxOpenId}
                      flags={this.props.flags}
                      setOptionBoxRef={this.setOptionBoxRef.bind(this)}
                      optionBoxDirection={this.state.optionBoxDirection}
                      toggleOptionsBox={this.toggleOptionsBox.bind(this)}
                      archiveChat={this.archiveChat.bind(this)}
                      itemDescription={
                        <ChatDescription chat={item} flags={this.props.flags} />
                      }
                      formatMessage={formatMessage}
                      emitEvent={this.emitEvent.bind(this)}
                      onOptionDivClick={this.onOptionDivClick}
                    />
                  </Card>
                </List.Item>
              )}
            />
          </InfiniteScroll>
        ) : (
          ""
        )}
        <SystemMessages
          listLength={this.props.list.length}
          loading={this.props.loading}
          hasErrors={this.props.hasErrors}
          isSearching={this.props.isSearching}
          resetFilters={this.props.resetFilters}
          createChat={this.props.createChat}
          reconnect={this.props.reconnect}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  createChat: (chat) => dispatch(createChat(chat)),
});

export default connect(null, mapDispatchToProps)(injectIntl(ChatList));
